module.exports = __webpack_public_path__ + "static/media/btc.54980210.png";